import { BANKS, BANKS_OPTIONS } from '../../constants';
import { allowedTenantBankIds } from '../../brand/tenant';
import Checkbox from '../Inputs/Checkbox/Checkbox';
import { useEffect, useMemo, useState } from 'react';
import styles from '../../pages/Deal/deal.module.css';

const BANK_LOGOS = {
  [BANKS.MYCAR]: '/assets/logos/finance-logo.jpg',
};

// allowedBankIds — какие банки вообще можно выбрать (для БУ-авто это пять
// банков из USED_CAR_BANK_IDS). Остальные не показываем и не отдаём в onChange,
// даже если они были отмечены в сохранённом черновике. Поверх этого брокер
// может работать не со всеми банками (JS Avto — только БЦК, Freedom и Шинхан).
const BanksPicker = ({ onChange, defaultValue, allowedBankIds }) => {
  const options = useMemo(() => {
    const allowed = allowedTenantBankIds(Array.isArray(allowedBankIds) ? allowedBankIds : null);
    return Array.isArray(allowed) ? BANKS_OPTIONS.filter((bank) => allowed.includes(bank.value)) : BANKS_OPTIONS;
  }, [allowedBankIds]);

  const [data, setData] = useState(() => {
    const selectedBanks = Array.isArray(defaultValue) ? defaultValue.map(String) : null;

    return BANKS_OPTIONS.reduce(
      (acc, bank) => ({
        ...acc,
        [bank.value]: selectedBanks ? selectedBanks.includes(String(bank.value)) : true,
      }),
      {}
    );
  });
  const handleChange = (id, value) => {
    setData({
      ...data,
      [id]: value,
    });
  };

  useEffect(() => {
    const allowed = new Set(options.map((bank) => bank.value));
    onChange(
      Object.keys(data)
        .filter((key) => data[key])
        .map(Number)
        .filter((id) => allowed.has(id))
    );
  }, [data, onChange, options]);

  return (
    <div>
      {options.map((bank) => (
        <label htmlFor={bank.value} className={styles.bank} style={{ padding: '5px 20px', marginBottom: 2, display: 'block', cursor: 'pointer' }}>
          <div className={styles.bank__row} style={{ marginBottom: 0 }}>
            <p className={styles.bank_name}>{bank.label}</p>
            <p>
              <Checkbox id={bank.value} value={data[bank.value]} defaultChecked={data[bank.value]} onChange={handleChange} />
            </p>
          </div>
        </label>
      ))}
    </div>
  );
};

export default BanksPicker;
